import React from 'react';
import PropTypes from 'prop-types';
import { Button, Card, CardBody, Col, Row } from 'react-bootstrap';
import { reverse } from 'named-urls';
import classNames from 'classnames';
import { useNavigate } from 'react-router-dom';
import RouterPaths from '../constants/RouterPaths';
import { DealerNavSections } from '../constants/DealerNavSections';

function DealerSectionsNav({ section, id }) {
  const navigate = useNavigate();

  const buttons = [
    {
      key: 'information',
      label: 'Information',
      path: reverse(RouterPaths.DEALER_INFORMATION, { id }),
      isActive: !section,
    },
    {
      key: DealerNavSections.USERS,
      label: 'Users',
      path: reverse(RouterPaths.USERS_DEALER, { dealerId: id }),
    },
    {
      key: DealerNavSections.VEHICLES,
      label: 'Vehicles',
      path: reverse(RouterPaths.VEHICLES_DEALER, { dealerId: id }),
    },
    {
      key: DealerNavSections.BIDS,
      label: 'Bids',
      path: reverse(RouterPaths.BIDS_DEALER, { dealerId: id }),
    },
    {
      key: DealerNavSections.TRANSACTIONS,
      label: 'Transactions',
      path: reverse(RouterPaths.TRANSACTIONS_DEALER, { dealerId: id }),
    },
    {
      key: DealerNavSections.INVOICES,
      label: 'Invoices',
      path: reverse(RouterPaths.INVOICES_DEALER, { dealerId: id }),
    },
    {
      key: DealerNavSections.BLACKLIST,
      label: 'Blacklist',
      path: reverse(RouterPaths.DEALER_BLACKLIST, { id }),
    },
  ];

  return (
    <Row>
      <Col>
        <Card>
          <CardBody>
            <div className="d-flex gap-2 flex-wrap">
              {buttons.map(({ key, label, path, isActive }) => {
                const active = isActive ?? section === key;
                const btnClass = classNames(
                  'rounded-pill',
                  active ? 'btn-primary' : 'btn-soft-primary',
                );

                return (
                  <Col xs="auto" key={key}>
                    <Button className={btnClass} onClick={() => navigate(path)} size="md">
                      {label}
                    </Button>
                  </Col>
                );
              })}
            </div>
          </CardBody>
        </Card>
      </Col>
    </Row>
  );
}

DealerSectionsNav.propTypes = {
  section: PropTypes.string,
  id: PropTypes.string.isRequired,
};
DealerSectionsNav.defaultProps = {
  section: null,
};

export default DealerSectionsNav;
